import { render, staticRenderFns } from "./awsResources.vue?vue&type=template&id=640cb07b&"
import script from "./awsResources.vue?vue&type=script&lang=js&"
export * from "./awsResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports